import { render, staticRenderFns } from "./WarehouseAreaOverview.vue?vue&type=template&id=d4d10aa4&scoped=true&"
import script from "./WarehouseAreaOverview.vue?vue&type=script&lang=js&"
export * from "./WarehouseAreaOverview.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseAreaOverview.vue?vue&type=style&index=0&id=d4d10aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d10aa4",
  null
  
)

export default component.exports